"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TDocDeployerErrors__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "ImplementationAlreadyAdded",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes",
    name: "payload",
    type: "bytes"
  }],
  name: "ImplementationInitializationFailure",
  type: "error"
}, {
  inputs: [],
  name: "InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "UnsupportedImplementationContractAddress",
  type: "error"
}];

class TDocDeployerErrors__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TDocDeployerErrors__factory = TDocDeployerErrors__factory;

_defineProperty(TDocDeployerErrors__factory, "abi", _abi);